export function buttonTarget() {
	$('button[data-href]').click( function( e ){
		let target = $(e.target);
		if ( target.not( 'a' )) {
			e.preventDefault();
			if ( $( this ).attr( 'data-window' ) == 'new' ) {
				window.open( $( this ).attr( 'data-href' ) );
			} else {
				window.location.href = $( this ).attr( 'data-href' );
			}
			return false;
		}
	});
}

export function init() {
	buttonTarget();
}
